import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import tokens from "../_tokens"
import { Search } from "./"

const StyledHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${tokens.color.bgDark};
  height: ${tokens.size.headerHeight}px;
  padding: 0 ${3.5 * tokens.size.base}px;
`

const StyledLogoPlaceholder = styled.div`
  font-size: ${tokens.fontSize.heading.l};
  color: ${tokens.color.white};
  text-transform: uppercase;
`

function Header() {
  return (
    <StyledHeader>
      <StyledLogoPlaceholder>Your logo</StyledLogoPlaceholder>
      <Search />
    </StyledHeader>
  )
}

Header.propTypes = {
  isSearchEnabled: PropTypes.bool,
}

Header.defaultProps = {
  isSearchEnabled: true,
}

export default Header
